<script setup lang="ts">
import { AlertType } from '@/constants/ui'

interface ButtonAlertSecondaryProps {
  label: string
  type: AlertType
}

const props = defineProps<ButtonAlertSecondaryProps>()
const borderColorClasses = {
  [AlertType.danger]: 'border-radical_red-500',
  [AlertType.info]: 'border-lochmara-600',
  [AlertType.success]: 'border-keppel-500',
  [AlertType.warning]: 'border-lightning_yellow-500',
}
const textColorClasses = {
  [AlertType.danger]: 'text-radical_red-500',
  [AlertType.info]: 'text-lochmara-600',
  [AlertType.success]: 'text-keppel-500',
  [AlertType.warning]: 'text-lightning_yellow-500',
}
</script>

<template>
  <button
    class="inline-flex items-center justify-center gap-2 rounded-[3.125rem] border border-current"
    :class="`${borderColorClasses[props.type]} ${textColorClasses[props.type]} bg-white px-6 py-3 text-base hover:cursor-pointer`"
    type="button"
  >
    <span>{{ props.label }}</span>
  </button>
</template>
